<app-loader></app-loader>
<div class="layout admin-layout" [ngClass]="{ 'sidebaropen': togglesidebar}">
    <app-menu (toggleSidebar)="handleSidebarToggle()"></app-menu>
    <div class="app-container">
        <p-toast></p-toast>
        <app-topbar (topbartoggleSidebar)="handleSidebarToggle()"></app-topbar>
        <div class="app-component">
            <app-breadcrumb></app-breadcrumb>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>